import { createContext } from "react";

export const preFetchContext = createContext("");